<ng-select class="form-control"
           [formControl]="control"
           [attr.test-id]="descriptor.zoneID"
           [idField]="'value'"
           [textField]="'display'"
           [items]="items"
           [disabled]="readOnly"
           [readOnly]="readOnly">
</ng-select>
